/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Product collection slider scroll indicators (homepage + PDP recommendations)
  function initCollectionSliderScrollbars() {
    const sliders = document.querySelectorAll('.index-products .grid--mobile-slider');
    sliders.forEach((slider) => {
      const gridOuter = slider.closest('.grid-outer');
      if (!gridOuter) return;

      const items = slider.querySelectorAll(':scope > .grid-item');
      const slidesCount = items.length;
      if (slidesCount < 2) return;

      gridOuter.style.setProperty('--slides-count', slidesCount);
      gridOuter.style.setProperty('--slider-index', 0);

      slider.addEventListener('scroll', () => {
        const maxScroll = slider.scrollWidth - slider.clientWidth;
        if (maxScroll <= 0) return;
        const progress = slider.scrollLeft / maxScroll;
        const index = progress * (slidesCount - 1);
        gridOuter.style.setProperty('--slider-index', index);
      });
    });
  }

  // Product page mobile slider dot indicators
  function initProductSliderDots() {
    const container = document.querySelector('.product__images--mobile-slider');
    if (!container) return;

    const slider = container.querySelector('.product__slides');
    if (!slider) return;

    const slides = slider.querySelectorAll('.product__slide');
    const slidesCount = slides.length;
    if (slidesCount < 2) return;

    // Create dots container
    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'product-slider-dots';

    const dots = [];
    for (let i = 0; i < slidesCount; i++) {
      const dot = document.createElement('span');
      dot.className = 'product-slider-dots__dot';
      if (i === 0) dot.classList.add('is-active');
      dotsContainer.appendChild(dot);
      dots.push(dot);
    }

    container.appendChild(dotsContainer);

    let activeIndex = 0;

    slider.addEventListener('scroll', () => {
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      if (maxScroll <= 0) return;
      const progress = slider.scrollLeft / maxScroll;
      const newIndex = Math.round(progress * (slidesCount - 1));
      if (newIndex !== activeIndex) {
        dots[activeIndex].classList.remove('is-active');
        activeIndex = newIndex;
        dots[activeIndex].classList.add('is-active');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initCollectionSliderScrollbars();
      initProductSliderDots();
    });
  } else {
    initCollectionSliderScrollbars();
    initProductSliderDots();
  }
})();
